import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from './store'

interface AuthState {
  authenticated: boolean
  initialized: boolean
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    authenticated: false,
    initialized: false
  },
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state = {
        initialized: true,
        authenticated: action.payload
      }
      return state
    }
  }
})

// selectors
export const selectIsAuthenticated = (state: RootState) => {
  return state.auth?.authenticated === true
}

export const selectIsInitialized = (state: RootState) => {
  return state.auth?.initialized === true
}

export const {setAuthenticated} = authSlice.actions

// reducer
export default authSlice.reducer
